import React from "react";
import { useEffect, useState, createContext, useRef } from 'react';
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";

export const VentasInternasSection = ({ data }) => {
    const [ventas, setVentas] = useState([]);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });


    useEffect(() => {
        setVentas(data)
    }, [data]);

    return (
        <div className="listado-fiscal-invoicemovimientos-container">
            <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
                <table>
                    <thead>
                        <tr>
                            {/* <th>
                                ID
                            </th> */}
                            <th>
                                Sucursal
                            </th>
                            <th>
                                <div>Departamento</div>
                            </th>
                            <th>
                                <div>Cuenta</div>
                            </th>
                            <th>
                                <div>Fecha</div>
                            </th>
                            <th>
                                <div>Importe</div>
                            </th>
                            <th>
                                <div>Serie Fiscal</div>
                            </th>
                            <th>
                                <div>Folio Fiscal</div>
                            </th>
                            <th>
                                <div>Batch</div>
                            </th>
                            <th>
                                <div>UUID</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {ventas.map((vn) => (
                            <tr>
                                {/* <td className="ta-center">{vn.idmovimiento}</td> */}
                                <td className="ta-center">{capitalizePalabras(vn.sucursal)}</td>
                                <td className="ta-center">{capitalizePalabras(vn.departamento)}</td>
                                <td className="ta-center">{vn.cuenta}</td>
                                <td className="ta-center">{new Date(vn.fecha).toLocaleDateString("es-MX", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric"
                                })}</td>
                                <td className="ta-right">{FormatMoney(vn.importe)}</td>
                                <td className="ta-center">{vn.serie_fiscal}</td>
                                <td className="ta-center">{vn.folio_fiscal}</td>
                                <td className="ta-center">{vn.batch}</td>
                                <td className="ta-center">{vn.uuid}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
